export default {
  'meta': {
    'langName': 'CROATIAN',
    'lang': 'Hrvatski'
  },
  'title': 'POVLAČENJE PROIZVODA ELEKTRIČNI ROMOBIL SD500E ILI MD500E BTWIN',
  'description': '"Pozdrav,\n\nKupili ste električni romobil marke BTWIN SD 500E ili MD500E i zahvaljujemo vam na kupnji.\n\nVaša sigurnost nam je prioritet, molimo pročitajte sljedeće informacije.\n\nUnatoč rigoroznim postupcima kontrole kvalitete, utvrdili smo sigurnosni nedostatak u električnim romobilima marke BTWIN SD500E i MD500E. Intenzivna upotreba može dovesti do pojave pukotine na spoju okvira i lule. Ovaj nedostatak može uzrokovati pucanje ovog spoja, što rezultira rizikom od pada za korisnika.\n\nPredlažemo da odgovorite na sljedeća pitanja kako bismo vam mogli pružiti sigurnosno rješenje za vaš proizvod.\n\nIspričavamo se zbog eventualnih neugodnosti i zahvaljujemo vam na ukazanom povjerenju.\n\nDECATHLON"',
  'emailConfirmation': {
    'title': 'Prvo, molimo Vas da potvrdite svoju adresu e-pošte i državu prebivališta:'
  },
  'fields': {
    'country': 'Država',
    'address': 'E-pošta',
    'email': 'E-pošta',
    'phonePrefix': 'Pozivni broj',
    'phone': 'Telefonski broj',
    'validations': {
      'phoneOrEmail': 'Molimo navedite barem adresu e-pošte ili broj telefona.',
      'email': 'Molimo, unesite važeću adresu',
      'phone': 'Molimo, unesite važeći broj telefona',
      'selectAddress': 'Molimo odaberite potpunu adresu s popisa (broj ulice, naziv ulice i grad).',
      'incompleteAddress': 'Adresa mora sadržavati kućni broj, naziv ulice i grad. Upišite barem kućni broj i ulicu, a zatim odaberite prijedlog.'
    },
    'firstName': 'Prezime',
    'lastName': 'Ime',
    'deliveryAddress': 'Adresa za dostavu paketa',
    'additionalAddress': 'Dodatne pojedinosti o adresi',
    'city': 'Grad',
    'zip': 'Poštanski broj',
    'readConfirmation': 'Potvrđujem da su moji kontaktni podaci točni, potvrđujem da sam pročitao/la navedene uvjete i slažem se da ću ih poštivati.',
    'choose': 'Odaberi',
    'required': 'Ovo polje je obavezno',
    'deliveryAddressHelp': 'Unesite kućni broj i naziv, a zatim odaberite potpunu adresu s popisa.',
    'streetOnlyHint': 'Dodajte kućni broj'
  },
  'ownerCheck': {
    'title': 'Jeste li još uvijek vlasnik jednog ili više električnih romobila BTWIN SD500E i MD500E?'
  },
  'yes': 'DA',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Imate li kontakt podatke trenutnog vlasnika?',
    'confirmation': 'Poštovani,\n\nHvala Vam na sudjelovanju u ovoj inicijativi.\n\nIspričavamo se zbog neugodnosti i zahvaljujemo Vam na ukazanom povjerenju.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Molimo navedite količinu električnih romobila BTWIN SD500E i MD500E.',
    'descriptionSd500': 'Romobil SD500E',
    'descriptionEmd500e': 'Romobil MD500E',
    'modelNumberHelp': 'Broj modela (SD500E ili MD500E) možete pronaći ispod vašeg romobila, kao što je prikazano dolje.',
    'quantity': 'Količina',
    'confirmation': '"Hvala vam što ste ispunili ovaj obrazac. Vaš je zahtjev uspješno registriran.\n\nObavijestit ćemo vas u roku od najviše 20 dana o datumu od kojeg možete izvršiti popravak.\n\nUgodan dan,\n\nDECATHLON"'
  },
  'repair': {
    'title': 'Popravak uz Vaše sudjelovanje',
    'description': '"Molimo vas da prestanete koristiti romobil.\n\nKomplet za popravak i upute bit će vam poslani na kućnu adresu kako biste mogli osigurati svoj romobil. Ovaj komplet bit će vam poslan besplatno; brzo se i jednostavno sastavlja.\n\nNakon prikupljanja vaših podataka, kontaktirat ćemo vas u roku od najviše 20 dana kako bismo potvrdili kada će vaš komplet za popravak biti dostupan. Imajte na umu da ćemo uložiti sve napore kako bismo smanjili kašnjenja."',
    'videoLink': 'Poveznica na video',
    'store': 'Poveznica na tekst',
    'kitLabel': 'Potpuni set za popravak',
    'docLabel': 'Upute za popravak',
    'callToAction': 'Kliknite ovdje kako biste dobili svoj besplatni komplet za popravak',
    'infoConfirmation': 'Molimo provjerite svoje podatke',
    'validateConfirmation': 'Potvrditi',
    'backConfirmation': 'Natrag'
  },
  'repairRequest': {
    'title': 'Molimo unesite sljedeće podatke kako biste primili svoj komplet za popravak:'
  },
  'form': {
    'submit': 'Sljedeće'
  },
  'status': 'Translation validated by COUNTRY'
} as const
